import { render, staticRenderFns } from "./EducationalStandardsSelect.vue?vue&type=template&id=563c4a64&scoped=true&lang=pug&"
import script from "./EducationalStandardsSelect.vue?vue&type=script&lang=ts&"
export * from "./EducationalStandardsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c4a64",
  null
  
)

export default component.exports